export const TOAST_AUTO_CLOSE = 60000;
